import React, { useMemo, useState } from 'react';
import QRCode from "react-qr-code";
import Modal from '../../../../../Common/Modal';

interface Props {
  gameCode: string;
}

const GameLink: React.FC<Props> = ({ gameCode }) => {
  const [showQRModal, setShowQRModal] = useState(false);
  const [copiedCode, setCopiedCode] = useState(false);
  const [copiedLink, setCopiedLink] = useState(false);

  const pathWithoutCode = useMemo(() => {
    return window.location.href
      .substring(0, window.location.href.indexOf(gameCode))
      .replace("http://", "")
      .replace("https://", "")
  }, [gameCode]);

  const copyGameCode = () => {
    if (gameCode) {
      navigator.clipboard.writeText(gameCode);
      setCopiedCode(true);
      setTimeout(() => setCopiedCode(false), 1000);
    }
  };

  const shareGameLink = () => {
    navigator.clipboard.writeText(window.location.href);
    setCopiedLink(true);
    setTimeout(() => setCopiedLink(false), 1000);
  };

  return (
    <>
      <div className="flex flex-col items-center space-y-3 sm:space-y-4">
        {/* Game Link Display */}
        <div className="bg-white/90 backdrop-blur-sm rounded-xl sm:rounded-2xl p-3 sm:p-4 shadow-lg border border-white/20 w-full mx-2 sm:mx-0">
          <div className="text-center">
            <div className="flex flex-wrap items-center justify-center gap-1 text-xs sm:text-sm">
              <span className="text-gray-700 break-all">{pathWithoutCode}</span>
              <span className="bg-gradient-to-r from-orange-400 to-orange-500 text-white px-2 sm:px-3 py-1 rounded-full font-bold text-sm sm:text-base shadow-md whitespace-nowrap">
                {gameCode}
              </span>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="w-full flex gap-2 sm:gap-3">
          <button 
            onClick={copyGameCode}
            className={`${copiedCode ? 'bg-green-500' : 'bg-blue-500 hover:bg-blue-600'} text-white w-full py-2 rounded-lg sm:rounded-xl font-medium shadow-lg transform hover:scale-105 transition-all duration-200 text-sm sm:text-base flex items-center justify-center`}
          >
            {copiedCode ? '✓' : 'Copy Code'}
          </button>
          <button 
            onClick={shareGameLink}
            className={`${copiedLink ? 'bg-green-500' : 'bg-green-500 hover:bg-green-600'} text-white w-full py-2 rounded-lg sm:rounded-xl font-medium shadow-lg transform hover:scale-105 transition-all duration-200 text-sm sm:text-base flex items-center justify-center`}
          >
            {copiedLink ? '✓' : 'Copy Link'}
          </button>
          <button 
            onClick={() => setShowQRModal(true)}
            className="bg-purple-500 hover:bg-purple-600 text-white w-full py-2 rounded-lg sm:rounded-xl font-medium shadow-lg transform hover:scale-105 transition-all duration-200 text-sm sm:text-base"
          >
            Show QR
          </button>
        </div>
      </div>

      {/* QR Code Modal */}
      <Modal
        isOpen={showQRModal}
        onClose={() => setShowQRModal(false)}
        title="Scan to Join Game"
        contentClassName="max-w-xs"
      >
        <div className="flex flex-col items-center">
          <div className="bg-white p-4 rounded-xl border-2 border-gray-200">
            <QRCode 
              size={200} 
              value={window.location.href}
              className="rounded-lg"
            />
          </div>
          <p className="text-gray-600 text-sm mt-4 text-center">
            Scan this QR code with your phone's camera to join the game
          </p>
        </div>
      </Modal>
    </>
  );
};

export default GameLink;